import Swal from 'sweetalert2';
import { isNil, isEmpty, has } from 'lodash';
export class AppUtil {

  static get_yyyy_MM_dd_Format(date: string): string {
    return date
      .split('-')
      .reverse()
      .join('-');
  }
  // alertType -- success or fail or static content
  // alertMessage -- success or fail message
  static getAlert(alertType: string, alertmessage: string) {
    console.log('get alert : ' + alertType);
    return Swal.fire(
      alertType + alertmessage,
      '',
      'error'
    );
  }
  static showSuccessAlert(alertmessage: string) {
    return Swal.fire(
      alertmessage,
      '',
      'success'
    );
  }
  static keyExists(data: any, keyName: string) {
    return has(data, keyName);
  }
  static isNullOrEmpty(data: any) {
    return isNil(data) || isEmpty(data);
  }
  static validHttpResponse(response: any) {
    if (isNil(response) || isEmpty(response)) {
      return false;
    }
    if (has(response, 'status') && response.status === 'success') {
      return true;
    }
    return false;
  }
  static showError(errorObj) {
    if (errorObj.status && errorObj.status === 401) {
      return;
    }
    if (errorObj.error && errorObj.error.type && errorObj.error.error) {
      if (errorObj.error.type === 'AppError') {
        return Swal.fire('Service is down, Please try again after sometime', '', 'error');
      }
      if (errorObj.error.type === 'UserError') {
        return Swal.fire(errorObj.error.error, '', 'error');
      }
    } else {
      return Swal.fire('Service is down, Please try again later', '', 'error');
    }
  }
  // static getReportUrl(params) {
  //   //let url = 'reportName=' + name
  //   let url = `tenant_id=${environment.tenant_id}`

  //   if (params.reportName == 'TourPassengerChart') {
  //     url += '&P_Journey_Date=' + params.P_From_Date
  //   }


  //   let keys = Object.keys(params)
  //   let b = false
  //   keys.forEach(key => {
  //     if (b) {
  //       b = false
  //       url += key + '=' + params[key]
  //     }
  //     else {
  //       url += '&' + key + '=' + params[key]
  //     }
  //   });
  //   console.log('url = ' + url);
  //   return url
  // }


}
